/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Stats_AriaInputs */

const en_landing_stats_aria = /** @type {(inputs: Landing_Stats_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform statistics`)
};

const de_landing_stats_aria = /** @type {(inputs: Landing_Stats_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattformstatistiken`)
};

const fr_landing_stats_aria = /** @type {(inputs: Landing_Stats_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiques de la plateforme`)
};

const es_landing_stats_aria = /** @type {(inputs: Landing_Stats_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas de la plataforma`)
};

const it_landing_stats_aria = /** @type {(inputs: Landing_Stats_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiche della piattaforma`)
};

const nl_landing_stats_aria = /** @type {(inputs: Landing_Stats_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformstatistieken`)
};

const pl_landing_stats_aria = /** @type {(inputs: Landing_Stats_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statystyki platformy`)
};

const fi_landing_stats_aria = /** @type {(inputs: Landing_Stats_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alustan tilastot`)
};

const da_landing_stats_aria = /** @type {(inputs: Landing_Stats_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformstatistikker`)
};

const sv_landing_stats_aria = /** @type {(inputs: Landing_Stats_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattformsstatistik`)
};

/**
* | output |
* | --- |
* | "Platform statistics" |
*
* @param {Landing_Stats_AriaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_stats_aria = /** @type {((inputs?: Landing_Stats_AriaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Stats_AriaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_stats_aria(inputs)
	if (locale === "fr") return fr_landing_stats_aria(inputs)
	if (locale === "es") return es_landing_stats_aria(inputs)
	if (locale === "it") return it_landing_stats_aria(inputs)
	if (locale === "nl") return nl_landing_stats_aria(inputs)
	if (locale === "pl") return pl_landing_stats_aria(inputs)
	if (locale === "fi") return fi_landing_stats_aria(inputs)
	if (locale === "da") return da_landing_stats_aria(inputs)
	if (locale === "sv") return sv_landing_stats_aria(inputs)
	return en_landing_stats_aria(inputs)
});